import { animateOnScroll } from '../../../assets/js/utility/scroll-animation';

$(function () {
  if ($('.request-customer-story')[0]) {
    const container = $('.request-customer-story-container');
    animateOnScroll(container);
  }
});
